import { render, staticRenderFns } from "./PricingPreviewCalculator.vue?vue&type=template&id=6d1ef4b2&scoped=true&"
import script from "./PricingPreviewCalculator.vue?vue&type=script&lang=js&"
export * from "./PricingPreviewCalculator.vue?vue&type=script&lang=js&"
import style0 from "./PricingPreviewCalculator.vue?vue&type=style&index=0&id=6d1ef4b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1ef4b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable,VIcon,VSimpleTable})
